import React from 'react'
import {first, get} from 'lodash'
import {CSSTransition, SwitchTransition} from 'react-transition-group'
import {useLocation} from 'wouter'
import {SessionState, useSession} from '../lib'
import {Loading} from '.'
import {Team} from '../lib/model'

export interface PageProps {
  session: SessionState
  settings: Team
  params: Record<string, string>
}

export interface PageRoute {
  path: string | RegExp
  page: React.JSXElementConstructor<PageProps>
  id: (x: Record<string, string>) => string
  fallback?: boolean
  params?: Record<string, string>
}
interface PageRouterProps {
  routes: PageRoute[]
}
export function PageRouter({routes}: PageRouterProps) {
  const session = useSession()
  const settings = session.getSettings()
  const [location] = useLocation()
  const [title, setTitle] = React.useState('')
  const curRef = React.useRef<HTMLDivElement>(null)
  const [curRoute, saveRoute] = React.useState<PageRoute>()
  React.useEffect(() => {
    const matched = first(routes.filter(r => location.match(r.path))) || first(routes.filter(r => r.fallback))
    if (matched) {
      matched.params = get(location.match(matched.path), 'groups', {})
      const id = [settings.name, matched.id(matched.params)].filter(i => i).join(' : ')
      if (id !== title) {
        setTitle(id)
        saveRoute(matched)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])
  React.useEffect(() => {
    document.title = title
  }, [title])

  if (curRoute) {
    return (
      <React.Suspense fallback={<Loading />}>
        <SwitchTransition mode="out-in">
          <CSSTransition
            nodeRef={curRef}
            classNames="page"
            timeout={1000}
            key={title}
            // key={curRoute.page.name}
            // in={true}
            exit={false}
            unmountOnExit
          >
            <div id={curRoute.page.name} className="page" ref={curRef}>
              <curRoute.page session={session} settings={settings} params={curRoute.params || {}} />
            </div>
          </CSSTransition>
        </SwitchTransition>
      </React.Suspense>
    )
  }
  return null
}

// NOTE: leaving these bits here in case want to try to get exit animation to work
//
// const [[lastRoute, curRoute], saveRoutes] = React.useState<RouteSwitchRoute[]>([])
// const lastRef = React.useRef<HTMLDivElement>(null)
// if (matched && (!lastRoute || lastRoute.page.name !== curRoute.page.name)) {
//   matched.params = get(location.match(matched.path), 'groups', {})
//   document.title = [settings.name, matched.title(matched.params)].filter(i => i).join(' - ')
//   saveRoutes([curRoute, matched])
// }
// console.log('LAST ROUTE:', lastRef.current, 'NEW ROUTE:', curRef.current)
// return (
//     <SwitchTransition mode="out-in">
//       {lastRoute && (
//         <CSSTransition
//           // nodeRef={lastRef}
//           classNames="page"
//           timeout={1000}
//           key={lastRoute.page.name}
//           // in={false}
//           // key={location}
//           // key={nodeToAnimate.current?.id}
//           // exit={false}
//           unmountOnExit
//         >
//           <div id={lastRoute.page.name} className="page" ref={lastRef}>
//             <lastRoute.page session={session} settings={settings} params={lastRoute.params || {}} />
//           </div>
//         </CSSTransition>
//       )}
//       {curRoute && (
//         <CSSTransition
//           nodeRef={curRef}
//           classNames="page"
//           timeout={1000}
//           key={curRoute.page.name}
//           // in={true}
//           exit={false}
//           unmountOnExit
//         >
//           <div id={curRoute.page.name} className="page" ref={curRef}>
//             <curRoute.page session={session} settings={settings} params={curRoute.params || {}} />
//           </div>
//         </CSSTransition>
//       )}
//     </SwitchTransition>
// )
